module.exports = __webpack_public_path__ + "media/images/lp/1/voice2-open-0d9bd4adb17ef21d9f9e65954b5a7418.png";